import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import App from './App';
import Decodefiche from './pages/FicheDecode';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
       
        <Route path="/fiche-de-note" element={<Decodefiche />} />
        
      </Routes>
    </Router>
  </React.StrictMode>,

);